module.exports = __webpack_public_path__ + "img/Input_Search_Bar_Close.8d2fb362.svg";